interface Props {
  text: string
}

const ChartTitle = ({ text }: Props) => {
  return <h2 className='text-black text-lg font-semibold text-center'>{text}</h2>
}

export default ChartTitle
